import { getCustomTags } from 'app/crud/customTags.crud';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { put, select, takeLatest } from 'redux-saga/effects';
import { PERSIST_CUSTOM_TAGS, REDUCER_CUSTOM_TAGS } from '../conf';

export const actionTypes = {
  GetCustomTags: 'cms/GET_CUSTOM_TAGS',
  SetCustomTags: 'cms/SET_CUSTOM_TAGS',
};

const initialState = {
  data: [],
  loading: false,
};

export const reducer = persistReducer({ storage, key: PERSIST_CUSTOM_TAGS, whitelist: ['data'] }, (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetCustomTags:
      return { ...state, loading: true };

    case actionTypes.SetCustomTags: {
      const { response } = action.payload;
      return response ? { data: response, loading: false } : { ...state, loading: false };
    }

    default:
      return state;
  }
});

export const selectors = {
  getCustomTags: (state) => {
    return state.entities[REDUCER_CUSTOM_TAGS].data;
  },
};

export const actions = {
  getCustomTags: (params) => ({ type: actionTypes.GetCustomTags, payload: { params } }),
  fulfillCustomTags: (response) => ({ type: actionTypes.SetCustomTags, payload: { response } }),
};

export function* saga() {
  yield takeLatest(actionTypes.GetCustomTags, function* getCustomTagsSaga(action) {
    // Intentar obtener los datos de la caché primero
    const cachedCustomTags = yield select(selectors.getCustomTags);

    // Si hay datos en la caché, los usamos directamente
    if (cachedCustomTags && cachedCustomTags.length > 0) {
      yield put(actions.fulfillCustomTags(cachedCustomTags));
    } else {
      // Si no hay datos en la caché, llamamos a la API para obtenerlos
      const { data } = yield getCustomTags(action.payload.params);
      if (data?.status === 'success' && data.data) yield put(actions.fulfillCustomTags(data.data));
      else yield put(actions.fulfillCustomTags([]));
    }
  });
}
